export default __webpack_public_path__ + "static/Metal_Cliff_Platform-037d88e72cb79fee7b0dcee5d1248907.png";